"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
(0, jquery_1.default)(function () {
    (0, jquery_1.default)('.pwd-eye').on("click", function () {
        var $eye = (0, jquery_1.default)(this);
        var $password = $eye.parent().find("input");
        var $icon = $eye.find("i");
        var fa;
        if ($password.attr("type") === "password") {
            $password.attr("type", "text");
            fa = "fa-eye-slash";
        }
        else {
            $password.attr("type", "password");
            fa = "fa-eye";
        }
        $icon.removeClass();
        $icon.addClass("fa-solid");
        $icon.addClass(fa);
    });
});
